import { WorkflowChildState } from '../workflowChildState';

export interface TriggerState extends WorkflowChildState {}
